import * as React from "react";
import { connect } from "react-redux";
import { IRouterState } from "../redux/modules/router/reducer";
import {
  VIEWMODE_ADD,
  VIEWMODE_CURRENT_GCP_REQUEST,
  VIEWMODE_GCPREQUEST,
  VIEWMODE_INIT,
  VIEWMODE_MANAGE,
  VIEWMODE_PILOT,
  VIEWMODE_QC,
  VIEWMODE_READONLY,
  VIEWMODE_READONLY_NOSCAN,
} from "../redux/modules/router/routes";
import { getRouterState, IStoreState } from "../redux/rootReducer";
import AlignCenter from "./Generics/AlignCenter";
import Loader from "./Generics/Loader";
import { userOpensGcpApp } from "./scenarios";
import ModeCurrentGCPRequestPage from "./ModeCurrentGCPRequest/ModeCurrentGCPRequestPage";
import ModePilotPage from "./ModePilot/ModePilotPage";
import { RedirectToGcpRequestApp } from "./RedirectToGcpRequestApp/RedirectToGcpRequestApp";
import RedirectToQCApp from "./RedirectToQCApp/RedirectToQCApp";
import { RedirectToGcpRegistryApp } from "./RedirectToGcpRegistryApp/RedirectToGcpRegistryApp";

interface IRouterProps {
  routerState: IRouterState;
}

const Router = ({ routerState }: IRouterProps) => {
  if (!routerState.data || !routerState.data.viewMode) {
    return <AlignCenter>Router error: route not found</AlignCenter>;
  }

  switch (routerState.data.viewMode) {
    case VIEWMODE_QC:
      return (
        <RedirectToQCApp
          customerId={routerState.data.customerId}
          siteId={routerState.data.siteId}
          scanDate={routerState.data.scanDate}
        />
      );

    case VIEWMODE_READONLY_NOSCAN:
    case VIEWMODE_READONLY:
    case VIEWMODE_CURRENT_GCP_REQUEST: {
      return (
        <ModeCurrentGCPRequestPage
          customerId={routerState.data.customerId}
          siteId={routerState.data.siteId}
          returnUrl={routerState.data.returnUrl}
          from={routerState.data.from}
        />
      );
    }

    case VIEWMODE_GCPREQUEST:
      return <RedirectToGcpRequestApp />;
    case VIEWMODE_ADD:
      return <RedirectToGcpRequestApp />;
    case VIEWMODE_MANAGE:
      return <RedirectToGcpRegistryApp />;
    case VIEWMODE_INIT:
      return <RedirectToGcpRequestApp />;
    case VIEWMODE_PILOT:
      return (
        <ModePilotPage
          customerId={routerState.data.customerId}
          siteId={routerState.data.siteId}
        />
      );
    default:
      return <div>No view found for mode {routerState.data.viewMode}</div>;
  }
};
export default connect((state: IStoreState) => ({
  routerState: getRouterState(state),
}))(({ routerState }: IRouterProps) => (
  <Loader asyncAction={() => userOpensGcpApp()}>
    {() => <Router routerState={routerState} />}
  </Loader>
));
